import ApiCallerClient, {ApiMethod} from "../clients/apiCallerClient";

export default class TextToAkgEntityLinkingClient {

    constructor(apiHost) {
        this.apiHost = apiHost;
    }

    getEntities = async (text) => {
        
        const path = `/prod`;
        let response =  await ApiCallerClient.callApi({
            "endpoint": {
                "hostName": this.apiHost,
                "httpMethod": ApiMethod.POST,
                "path": path
            },
            "body": JSON.stringify({"text": text})
        });
        if (response.statusCode !== 200) {
            console.log(`Error fetching entity info from AKG ${response.message}`);
            return [];
        }
        
        return JSON.parse(response.body).entities;
    }
}